<template>
  <div class="Financial">
    <div class="headerGeneralSales">
      <div style="display: flex; width: 35%">
        <b-button class="BtnRegister">
          <b-icon-plus
            scale="1.5"
            @click.stop="handleModals('toReceive')"
            style="
              width: 30px;
              background: #006458;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-plus>
          <span @click.stop="activeTable('toReceive')" style="width: 170px"
            >Nova conta a receber</span
          >
        </b-button>
        <b-button
          class="BtnRegister"
          style="background: #fff2e5; border: 1px solid #fff2e5"
        >
          <b-icon-plus
            scale="1.5"
            @click.stop="handleModals('toPay')"
            style="
              width: 30px;
              background: #ffaf59;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-plus>
          <span @click.stop="activeTable('toPay')" style="width: 170px"
            >Nova conta a pagar</span
          >
        </b-button>
      </div>
      <div class="searchContainer">
        <div class="searchInput">
          <b-form-select
            v-if="this.kind === 'entrada'"
            class="searchFilter"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="type"
            :options="filterComboboxCustomer"
            @change="handleClearSituation"
          ></b-form-select>
          <b-form-select
            v-if="this.kind === 'saida'"
            class="searchFilter"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="type"
            :options="filterComboboxSupplier"
            @change="handleClearSituation"
          ></b-form-select>
          <div v-if="type === 'situacao'">
            <b-form-select
              class="searchFilterSituation custom-select2"
              value-field="value"
              text-field="text"
              v-model="textPesquisa"
              :options="filterSituation"
            ></b-form-select>
          </div>
          <div v-if="type === 'categoria'">
            <b-form-select
              value-field="id"
              text-field="nome"
              style="width: 150px"
              class="searchFilterSituation custom-select2"
              :options="allCategoryBills"
              v-model="idCategoryBill"
            >
            </b-form-select>
          </div>
          <div v-else>
            <b-input
              placeholder="Pesquisar por..."
              v-model="textPesquisa"
              @keyup.enter="filterSalePerMonth()"
            ></b-input>
          </div>
          <b-button size="sm" @click="filterSalePerMonth()" class="searchBtn">
            <b-icon-search></b-icon-search>
          </b-button>
        </div>
      </div>
      <div class="lineSearch">
        <div class="summaryMonth">
          Resumo: &nbsp;
          <strong>{{
            selectTextDate === "Personalizado" ? "" : `(${selectTextDate})`
          }}</strong>
        </div>
        <div class="pagMonth"></div>
        <div
          class="searchInput"
          style="
            padding: 0px !important;
            min-width: 40% !important;
            margin-left: 10px;
            display: flex;
            justify-content: space-between;
          "
          v-if="selectTextDate === 'Personalizado'"
        >
          <button class="btnPeriod" size="sm">Período</button>
          <div class="dateInput">
            <input
              type="date"
              id="date"
              v-model="startDate"
              style="
                padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                cursor: pointer;
                border-left: none;
                width: 100px;
                border-radius: 0px 5px 5px 0px;
              "
            />
            <input
              type="date"
              id="date"
              v-model="endDate"
              style="
                padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                cursor: pointer;
                width: 100px;
                border-right: none;
                border-radius: 5px 0 0 5px;
              "
            />
          </div>

          <b-button
            size="sm"
            @click="filterSalePerMonth()"
            class="searchBtnInp"
            style="border-left: 1px solid #c3c1c1"
          >
            <b-icon-search></b-icon-search>
          </b-button>
        </div>

        <div style="width: 25px">
          <DropdownFilters @handleFilterDays="handleFilterDays" />
        </div>
      </div>
    </div>

    <div class="SumFinancial">
      <!-- activeTable -->
    </div>
    <div class="ContainerSearchInput">
      <div v-if="this.kind === 'entrada'" class="textReceive">
        <span style="padding: 7px 0px 0px 4px">Contas a Receber</span>
      </div>
      <div v-if="this.kind === 'saida'" class="textPay">
        <span style="padding-top: 7px">Contas a Pagar</span>
      </div>
    </div>
    <div v-if="this.kind === 'entrada'" class="SumStateFinancial">
      <button
        @click="filterPerType"
        name="vencidas"
        class="ItemSumStateFinancial"
        style="
          border: 1px solid #e3ebe2;
          border-radius: 5px 0 0 5px;
          color: #c31d1d;
        "
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Todas parcelas vencidas</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              this.receivedSummary.sumMatury.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe todas as parcelas vencidas registradas no sistema. Para mais detalhes, consulte os relatórios financeiros.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
      <button
        @click="filterPerType"
        class="ItemSumStateFinancial"
        style="color: #403b74"
        name="vencem"
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Em aberto</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              (
                this.receivedSummary.expireToday + this.receivedSummary.toWin
              ).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe todas as parcelas em aberto do período selecionado. Para mais detalhes, consulte os relatórios financeiros.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
      <button
        @click="filterPerType"
        name="pago"
        class="ItemSumStateFinancial"
        style="color: #00c26b"
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Recebidos</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              this.receivedSummary.totalPaid.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe todas as parcelas recebidas dentro do período selecionado, considerando exclusivamente a data de recebimento.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
      <button
        @click="listTotalPeriod()"
        class="ItemSumStateFinancial"
        style="border-radius: 0 5px 5px 0; color: #4c4c4c"
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Total do Período</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              this.receivedSummary.monthTotal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe o total de todas as parcelas com data de vencimento dentro do período selecionado, incluindo as pagas, vencidas e em aberto.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
    </div>

    <div v-if="this.kind === 'saida'" class="SumStateFinancial">
      <button
        @click="filterPerType"
        name="vencidas"
        class="ItemSumStateFinancial"
        style="
          border: 1px solid #d9d9d9;
          border-radius: 5px 0 0 5px;
          color: #c31d1d;
        "
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Todas parcelas vencidas</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              this.payableSummary.sumMatury.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe todas as parcelas vencidas registradas no sistema. Para mais detalhes, consulte os relatórios financeiros.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
      <button
        @click="filterPerType"
        class="ItemSumStateFinancial"
        style="color: #403b74"
        name="vencem"
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Em aberto</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              (
                this.payableSummary.expireToday + this.payableSummary.toWin
              ).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe todas as parcelas em aberto do período selecionado. Para mais detalhes, consulte os relatórios financeiros.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
      <button
        @click="filterPerType"
        name="pago"
        class="ItemSumStateFinancial"
        style="color: #00c26b"
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Pagas</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              this.payableSummary.totalPaid.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe todas as parcelas recebidas dentro do período selecionado, considerando exclusivamente a data de recebimento.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
      <button
        @click="listTotalPeriod()"
        class="ItemSumStateFinancial"
        style="border-radius: 0 5px 5px 0; color: #4c4c4c"
      >
        <div></div>
        <div>
          <p style="margin: 0px; padding: 0px">Total do Período</p>
          <b-spinner v-if="spinSummary" small></b-spinner>
          <p style="margin: 0px; padding: 0px" v-else>
            {{
              this.payableSummary.monthTotal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </p>
        </div>
        <div>
          <b-button
            class="btn-info-cards"
            v-b-popover.hover.top="
              'Exibe o total de todas as parcelas com data de vencimento dentro do período selecionado, incluindo as pagas, vencidas e em aberto.'
            "
          >
            <b-icon-question-circle-fill scale="1" />
          </b-button>
        </div>
      </button>
    </div>
    <ToPayTable
      :payFilter="payFilter"
      :dataLength="dataLength"
      v-if="tableActive.toPay"
    />
    <ToReceiveTable
      :dataLength="dataLength"
      :receiveFilter="receiveFilter"
      v-if="tableActive.toReceive"
    />

    <div class="setBtn">
      <button class="itemBtn" :disabled="page == 1" @click="previousPage(page)">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button
        class="itemBtn"
        :disabled="this.dataLength < 9"
        @click="nextPage(page)"
      >
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>

    <div :class="sizeModalFinancial">
      <div :class="modalContainerFinancial" v-if="colapseFinancial">
        <b-button class="closeModal" @click="modalHeight"> X </b-button>
        <Bill v-if="enableModalsFinancial.toReceive" />
        <Bill
          v-if="enableModalsFinancial.toPay"
          title="Nova Despesa"
          type="saida"
          label="Conta de Pagamento"
          :isProvider="true"
        />
        <BillDetails v-if="enableModalsFinancial.billDetails" />
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../services/axios";
import { DateTime } from "luxon";
import ToPayTable from "./ToPayTable.vue";
import ToReceiveTable from "./ToReceiveTable.vue";
import Bill from "../Bill/Index-Bill.vue";
import BillDetails from "../BillDetails/Index-Bill-Details.vue";
import receiveImg from "../../assets/cashReceive.svg";
import payImg from "../../assets/cashPay.svg";
import serviceCategoryBill from "../../services/serviceCategoryBill";
import DropdownFilters from "../../components/UI/DropdownFilters/DropdownFilters.vue";

import { mapMutations, mapState } from "vuex";
export default {
  components: {
    ToPayTable,
    ToReceiveTable,
    Bill,
    BillDetails,
    DropdownFilters,
  },
  data() {
    return {
      receiveImg: receiveImg,
      selectTextDate: "Hoje",
      payImg: payImg,
      textPesquisa: "",
      type: "",
      status: "",
      kind: "entrada",
      page: 1,
      startDate: "",
      endDate: "",
      userLevel: "",
      spinSummary: false,
      isAdvancedSearch: false,
      year: DateTime.local().year,
      month: DateTime.local().month.toString(),
      filterComboboxSupplier: [
        { value: "nomeFantasia", text: "Fornecedor" },
        { value: "situacao", text: "Situação" },
        { value: "valorTotal", text: "Valor da Parcela" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "categoria", text: "Categoria" },
        { value: "codigoReferencia", text: "Código Referencia" },
        { value: "", text: "Selecione..." },
      ],
      filterComboboxCustomer: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "numeroVenda", text: "Nº Venda" },
        { value: "situacao", text: "Situação" },
        { value: "valorTotal", text: "Valor da Parcela" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "codigoReferencia", text: "Código Referencia" },
        { value: "", text: "Selecione..." },
      ],
      filterSituation: [
        { value: "Em aberto", text: "Em aberto" },
        { value: "Pago", text: "Pago" },
        { value: "Pago Parcial", text: "Pago Parcial" },
        { value: "Perda", text: "Perda" },
        { value: "Vencido", text: "Vencido" },
        { value: "", text: "Selecionar situação..." },
      ],
      filterMonth: [
        { value: "1", text: "Janeiro" },
        { value: "2", text: "Fevereiro" },
        { value: "3", text: "Março" },
        { value: "4", text: "Abril" },
        { value: "5", text: "Maio" },
        { value: "6", text: "Junho" },
        { value: "7", text: "Julho" },
        { value: "8", text: "Agosto" },
        { value: "9", text: "Setembro" },
        { value: "10", text: "Outubro" },
        { value: "11", text: "Novembro" },
        { value: "12", text: "Dezembro" },
      ],
      filterYear: [
        { value: "2021", text: "2021" },
        { value: "2022", text: "2022" },
        { value: "2023", text: "2023" },
        { value: "2024", text: "2024" },
        { value: "2025", text: "2025" },
        { value: "2026", text: "2026" },
        { value: "2027", text: "2027" },
        { value: "2028", text: "2028" },
        { value: "2029", text: "2029" },
        { value: "2030", text: "2030" },
        { value: "2031", text: "2031" },
        { value: "2032", text: "2032" },
      ],
      receiveFilter: {},
      payFilter: {},
      allCategoryBills: [],
      idCategoryBill: "",
      dataLength: 0,
      tableActive: {
        toPay: false,
        toReceive: true,
      },
      receivedSummary: {
        totalReceive: 0,
        sumMatury: 0,
        monthTotal: 0,
        totalPaid: 0,
        expireToday: 0,
        toWin: 0,
      },
      payableSummary: {
        totalPay: 0,
        sumMatury: 0,
        monthTotal: 0,
        totalPaid: 0,
        expireToday: 0,
        toWin: 0,
      },
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_FINANCIAL",
      "SET_COLAPSE_FINANCIAL",
      "ALTER_TYPE_FINANCIAL",
      "ALTER_MODAL_CONTAINER_FINANCIAL",
      "SET_DATA_SEARCH_FROM_BILL",
      "SET_DEFAULT_TYPE_FINANCIAL",
      "SET_IS_SEARCH_BILLS",
    ]),

    async activeTable(typeBill) {
      this.clearSearch();

      if (typeBill === "toPay") {
        this.kind = "saida";
        this.tableActive = {
          toPay: true,
          toReceive: false,
        };
      } else {
        this.kind = "entrada";
        this.tableActive = {
          toPay: false,
          toReceive: true,
        };
      }

      await this.filterSalePerMonth();
    },

    async clearFilersAndSearch() {
      this.clearSearch();
      await this.filterSalePerMonth();
    },

    async listTotalPeriod() {
      this.textPesquisa = "";
      this.type = "";
      this.status = "";
      this.page = 1;
      this.idCategoryBill = "";

      await this.filterSalePerMonth();
    },

    filterPerType(event) {
      const button = event.currentTarget;
      let name = button.name;
      this.page = 1;

      this.status = name;
      this.type = "";
      this.textPesquisa = "";

      this.filterSalePerMonth();
    },

    async modalHeight() {
      this.SET_COLAPSE_FINANCIAL(!this.colapseFinancial);

      this.colapseFinancial
        ? this.ALTER_SIZE_MODAL_FINANCIAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL_FINANCIAL("disable");

      this.modalContainerFinancial
        ? this.ALTER_MODAL_CONTAINER_FINANCIAL("modalContainer")
        : this.ALTER_MODAL_CONTAINER_FINANCIAL("contentModalDisable");

      if (!this.colapseFinancial && this.sizeModalFinancial === "disable") {
        this.SET_DATA_SEARCH_FROM_BILL({});
      }

      await this.filterSalePerMonth();
    },

    async handleModals(name) {
      this.ALTER_TYPE_FINANCIAL(name);

      this.modalHeight();
    },

    async monthHasChanged() {
      await this.filterSalePerMonth();
    },

    async filterSalePerMonth() {
      try {
        this.spinSummary = true;

        const qs = `startDate=${this.startDate}&endDate=${this.endDate}&typeBill=${this.kind}&q=${this.textPesquisa}&collumnSearch=${this.type}&idCategoryBill=${this.idCategoryBill}&status=${this.status}&page=${this.page}`;

        const response = await api.get(`/bills/list/bills/?${qs}`);

        const {
          bills,
          totalPagar,
          totalReceber,
          vencidas,
          vencem,
          aVencer,
          recebidos,
          sumBills,
        } = response.data;

        this.dataLength = bills.length;

        if (this.kind === "entrada") {
          this.receiveFilter = bills;
        }

        if (this.kind === "saida") {
          this.payFilter = bills;
        }

        if (this.userLevel === "adm" || this.userLevel === "corporate") {
          this.payableSummary.totalPay = totalPagar;
          this.receivedSummary.totalReceive = totalReceber;

          this.receivedSummary.monthTotal = sumBills;

          this.receivedSummary.totalPaid = recebidos;
          this.receivedSummary.sumMatury = vencidas;
          this.receivedSummary.expireToday = vencem;
          this.receivedSummary.toWin = aVencer;

          this.payableSummary.monthTotal = sumBills;

          this.payableSummary.totalPaid = recebidos;
          this.payableSummary.sumMatury = vencidas;
          this.payableSummary.expireToday = vencem;
          this.payableSummary.toWin = aVencer;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.spinSummary = false;
      }
    },

    checkUserLevel() {
      this.userLevel = localStorage.getItem("userLevel");
    },

    async enableAdvancedSearch() {
      this.isAdvancedSearch = !this.isAdvancedSearch;
    },

    getTotalFinancer(financer) {
      return financer.reduce((total, fin) => total + fin.valorRestante, 0);
    },

    getMonthTotal(financer) {
      return financer.reduce((total, fin) => total + fin.valorTotal, 0);
    },

    getTotalPaid(financer) {
      return financer.reduce((total, fin) => total + fin.valorPago, 0);
    },

    async getAllCategoryBill() {
      const result = await serviceCategoryBill.fillComobobox();
      this.allCategoryBills = result;
    },

    async nextMoth(direction) {
      if (direction === "prev") {
        this.startDate = DateTime.fromSQL(this.startDate)
          .minus({ month: 1 })
          .startOf("month")
          .toSQLDate();
        this.endDate = DateTime.fromSQL(this.endDate)
          .minus({ month: 1 })
          .endOf("month")
          .toSQLDate();
      } else if (direction === "next") {
        this.startDate = DateTime.fromSQL(this.startDate)
          .plus({ month: 1 })
          .startOf("month")
          .toSQLDate();
        this.endDate = DateTime.fromSQL(this.endDate)
          .plus({ month: 1 })
          .endOf("month")
          .toSQLDate();
      }

      this.page = 1;

      await this.filterSalePerMonth();
    },
    nextPage() {
      this.filterSalePerMonth((this.page += 1));
    },
    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterSalePerMonth((this.page -= 1));
      }
    },
    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      this.status = "";
      this.startDate = DateTime.local().toSQLDate();
      this.endDate = DateTime.local().toSQLDate();
      this.page = 1;
      this.idCategoryBill = "";
    },
    async handleFilterDays(valueDate, textValueDate) {
      this.clearSearch();
      this.selectTextDate = textValueDate;

      const today = DateTime.local();

      switch (valueDate) {
        case "hoje":
          this.startDate = today.toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "esteMes":
          this.startDate = today.startOf("month").toSQLDate();
          this.endDate = today.endOf("month").toSQLDate();
          break;
        case "ontem":
          // eslint-disable-next-line no-case-declarations
          const yesterday = today.minus({ days: 1 });
          this.startDate = yesterday.toSQLDate();
          this.endDate = yesterday.toSQLDate();
          break;
        case "7dias":
          this.startDate = today.minus({ days: 7 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "30dias":
          this.startDate = today.minus({ days: 30 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "mesPassado":
          // eslint-disable-next-line no-case-declarations
          const lastMonth = today.minus({ months: 1 });
          this.startDate = lastMonth.startOf("month").toSQLDate();
          this.endDate = lastMonth.endOf("month").toSQLDate();
          break;
        case "ultimos3meses":
          this.startDate = today
            .minus({ months: 3 })
            .startOf("month")
            .toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        default:
          break;
      }

      await this.filterSalePerMonth();
    },

    handleClearSituation() {
      if (this.type !== "situacao") {
        this.textPesquisa = "";
      }
    },
  },
  computed: {
    ...mapState({
      sizeModalFinancial: (state) => state.sizeModalFinancial,
      enableModalsFinancial: (state) => state.enableModalsFinancial,
      colapseFinancial: (state) => state.colapseFinancial,
      modalContainerFinancial: (state) => state.modalContainerFinancial,
      isSearchBills: (state) => state.isSearchBills,
      dataSearchFromBill: (state) => state.dataSearchFromBill,
    }),
  },
  async mounted() {
    this.startDate = DateTime.local().toSQLDate();
    this.endDate = DateTime.local().toSQLDate();

    await this.filterSalePerMonth();
    this.getAllCategoryBill();

    if (
      this.dataSearchFromBill.idFornecedor &&
      this.dataSearchFromBill.valorTotal
    ) {
      this.handleModals("toPay");
    } else if (
      this.dataSearchFromBill.idCliente &&
      this.dataSearchFromBill.valorTotal
    ) {
      this.handleModals("toReceive");
    }
  },
  async created() {
    this.checkUserLevel();
  },

  beforeDestroy() {
    this.SET_DEFAULT_TYPE_FINANCIAL();
    this.SET_COLAPSE_FINANCIAL(false);
    this.ALTER_SIZE_MODAL_FINANCIAL("disable");
    this.ALTER_MODAL_CONTAINER_FINANCIAL("contentModalDisable");
    this.SET_DATA_SEARCH_FROM_BILL({});
  },

  watch: {
    isSearchBills() {
      this.filterSalePerMonth(this.page);
    },
  },
};
</script>
<style scoped>
.Financial {
  display: flex;
  flex-direction: column;
  margin-left: 90px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 13px;
}

.containerBtnNew {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-left: 10px;
  margin-top: 85px;
  gap: 30px;
}

.btnContaReceber {
  width: 275px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  color: #000;
  border: 1px solid #6666;
  border-radius: 3px;
  height: 40px;
}

.btnContaPagar {
  width: 275px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: space-between;
  background-color: transparent;
  color: #000;
  border: 1px solid #6666;
  border-radius: 3px;
  height: 40px;
}

.icon-receber {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  color: white;
  background: #004727;
}

.icon-pagar {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  color: white;
  background-color: #690000;
}

.ContainerBtnFinancial {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-left: 10px;
  margin-top: 70px;
  gap: 30px;
}

.BtnFinancial {
  width: 27%;
  border: none;
  height: 35px;
  border-radius: 3px;
  font-size: 13px;
  box-shadow: 0px 11px 4px -10px rgba(142, 142, 142, 0.78);
}
.BtnFinancial:hover {
  box-shadow: 0px 11px 4px -10px rgba(142, 142, 142, 0.78);
}

.SumFinancial {
  display: flex;
  width: 100%;
  gap: 30px;
  padding: 0 0 10px 0;
  border-bottom: 1px solid rgb(227, 227, 227);
  margin: 5px 0 0 10px;
  justify-content: flex-start;
  align-items: center;
}

.ItemSumFinancial {
  width: 27%;
  height: 55px;
  border-radius: 5px;
  font-size: 12px !important;
  color: rgb(88, 88, 88);
  gap: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  box-shadow: 0px 11px 4px -10px rgba(142, 142, 142, 0.78);
}

.ItemSumFinancial span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.ItemSumFinancial:hover {
  background: rgb(252, 252, 252);
}

.ItemSumFinancial:focus {
  background: rgb(249, 249, 249);
  border: none;
}

.lineSearch {
  display: flex;
  align-items: center;
  margin-left: 10px;
  gap: 0.5rem;
}

.searchByMonth {
  width: 27%;
  display: flex;
  align-items: center;
  margin: 10px 0px 3px 0px;
  border-radius: 5px;
  font-size: 11px;
  justify-content: space-between;
  border: 1px solid #e3e0e0;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.monthBtn {
  font-size: 11px;
  text-transform: capitalize;
  font-weight: bold;
  padding: 5px;
  cursor: context-menu;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.Arrows {
  border-radius: 5px;
  width: 25px;
  height: 20px;
}

.Arrows:hover {
  background: whitesmoke;
}

.radio-input {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  font-size: 12px;
  color: rgb(88, 88, 88);
  display: flex;
  width: 100%;
  gap: 30px;
  border-bottom: 1px solid rgb(227, 227, 227);
  justify-content: flex-start;
  align-items: center;
}

.radio-input input[type="radio"] {
  display: none;
}

.radio-input label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: 3px;
  height: 55px;
  width: 27%;
  box-shadow: 0px 11px 4px -10px rgba(142, 142, 142, 0.78);
  background-color: whitesmoke;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease-in-out;
}

.radio-input label:before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: transparent;
  border: 2px solid #ccc;
  transition: all 0.3s ease-in-out;
}

.radio-input input[type="radio"]:checked + label {
  animation: radio-translate 0.5s ease-in-out;
}

.radio-input input[type="radio"]:checked + label:before {
  background-color: transparent;
  top: 0;
}

.radio-input input[type="radio"].radio-receive:checked + label:before {
  background-color: #004727;
  border-color: #ccc;
}

.radio-input input[type="radio"].radio-pay:checked + label:before {
  background-color: #690000;
  border-color: #ccc;
}

@keyframes radio-translate {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateY(-5px);
  }

  100% {
    transform: translateX(0);
  }
}

.ContainerSearchInput {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 5px;
}

.cash {
  width: 30px;
  height: 30px;
}

.cashR {
  width: 35px;
  height: 35px;
}

.textPay {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #690000;
  font-size: 15px;
  font-family: Poppins-Regular, sans-serif !important;
}

.textReceive {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #006458;
  font-size: 15px;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchContainer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
}

.searchAdvancedContainer {
  gap: 20px;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px solid rgb(206, 206, 206);
  background: #ebebeb;
  border-radius: 2px;
  padding: 10px;
}

.searchInput {
  min-width: 45%;
  display: flex;
  padding: 3px 3px 3px 0;
  align-items: center;
  justify-content: flex-end;
}

.searchAvancedContent {
  min-width: 40%;
  display: flex;
  padding: 3px 0px 3px 0;
  align-items: center;
  justify-content: flex-end;
}

.searchFilter {
  width: 100px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  border-radius: 5px 0px 0px 5px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchMonth {
  width: 100px;
  height: 30px;
  border-radius: 5px 0px 0px 5px;
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchMonth:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchYear {
  width: 50px;
  height: 30px;
  border-radius: 0px 5px 5px 0px;
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchYear:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select3 {
  left: 4px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
  background: none;
  font-weight: bold;
  padding: 0 !important;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  font-weight: 600;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}

.searchFilterSituation {
  width: 100%;
  border-left: none !important;
  height: 30px;
  border-radius: 0px !important;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  position: relative !important;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchFilterSituation:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.custom-select2 {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
  background: none;
  font-weight: bold;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  width: 100px;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
  color: #006458;
}

.dateInput {
  display: flex;
  gap: 10px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
  font-size: 11px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}
.searchBtnInp {
  right: 0px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  width: 80px;
  height: 30px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.searchAvanced {
  justify-content: center;
  color: #3a4750;
  font-size: 12px;
  height: 30px;
  gap: 10px;
  padding: 0px 20px;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAvanced:hover {
  background: rgb(205, 205, 205);
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

input::placeholder {
  font-size: 11px;
}

button:focus {
  box-shadow: none;
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: absolute;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  cursor: auto;
}

.SumStateFinancial {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 3px 0 0 0;
}

.contentDivider {
  padding: 8px 0px;
}

.divider {
  width: 100%;
  border-bottom: solid 1px #6663605a;
}
.btn-info-cards {
  background: rgb(255, 255, 255);
  border: 1px solid rgb(228, 228, 228);
  color: #767777;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ItemSumStateFinancial {
  width: 100%;
  height: 50px;
  border: 1px solid #e3ebe2;
  border-left: none;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

.ItemSumStateFinancial p {
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSumStateFinancial:hover {
  background: rgb(249, 249, 249);
}

.ItemSumStateFinancial:focus {
  background: rgb(249, 249, 249);
  border-bottom: 3px solid #818485 !important;
}
.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: transparent;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModal:hover {
  background: whitesmoke;
  color: red;
}

.closeModal:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.summaryMonth {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  cursor: context-menu;
  padding: 0 0 0 7px;
  color: #2e2e2e;
}
.headerGeneralSales {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 65px;
  background: white;
  border-radius: 5px;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.headerCounter {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 5px;
  margin: 5px 0;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.BtnRegister {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 10px;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}

.BtnRegister:focus {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #d8d8d8;
  box-shadow: none;
}
.BtnCounter {
  width: 33.3%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3ebe2;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 1px;
  color: #006458;
  border: 1px solid #7ab5ae;
}
.BtnCounter:hover {
  background: #e3ebe2;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.Summary {
  display: flex;
  flex-direction: column;
  width: 40%;
  gap: 10px;
  justify-content: flex-start;
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.iconItem:hover {
  background: #006256;
  cursor: pointer;
}

.ItemSummarySales {
  height: 60px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSummarySales span {
  font-size: 13px;
  cursor: context-menu;
  letter-spacing: 1px;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ContainerSearchInput {
    padding-left: 0px;
  }
  .textReceive {
    font-size: 12px;
  }
  .searchContainer {
    gap: 2px;
    width: 83%;
  }
  .searchAll {
    display: none;
  }
  .searchFilter {
    width: 91px;
    height: 28px;
  }
  .searchInput {
    margin: 0px;
    padding: 3px 3px 3px 0;
  }
  .dateInput {
    gap: 3px;
  }
  input {
    height: 28px;
    font-size: 11px;
  }
  .btnPeriod {
    width: 70px;
    height: 28px;
    font-size: 11px;
  }
  .searchBtn {
    height: 28px;
  }
  .SumFinancial {
    margin: 0px;
    padding: 0px;
  }
  .ItemSumFinancial {
    height: 40px;
    align-items: center;
    justify-content: center;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }
  .itemBtn {
    width: 18px;
    height: 18px;
  }
  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 700px) {
  .ContainerSearchInput {
    padding-left: 1%;
    flex-direction: column;
    align-items: flex-start;
  }

  .searchContainer {
    display: flex;
    gap: 5px;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .btnPeriod {
    width: 100px;
    height: 30px;
    font-size: 11px;
  }

  .searchInput {
    min-width: 40%;
    width: 100%;
  }

  .dateInput {
    gap: 20px;
  }

  .searchAll {
    font-size: 13px;
    width: 150px;
    height: 30px;
  }

  .ItemSumFinancial {
    width: 19.8%;
    height: 60px;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ModalGeneral {
    width: calc(100% - 50px);
    left: 50px;
    top: 50px;
    overflow: none !important;
  }
  .closeModal {
    right: 0px;
  }
  .Financial {
    margin-left: 55px;
    padding: 0 0.5rem;
    width: calc(100% - 60px);
    font-size: 11px;
  }
  .ContainerBtnFinancial {
    margin-left: 5px;
    margin-top: 65px;
  }
  .BtnFinancial {
    width: 34%;
    height: 30px;
    font-size: 11px;
  }
  .SumFinancial {
    margin: 5px 0 0 5px;
    padding: 0 0 5px 0;
  }
  .lineSearch {
    margin-left: 5px;
  }
  .searchByMonth {
    width: 34%;
    font-size: 10px;
  }
  .ItemSumFinancial {
    width: 34%;
    height: 50px;
    gap: 0px;
    font-size: 11px !important;
  }
}

@media screen and (max-width: 700px) {
  .Financial {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
    width: 100%;
    height: 100vh;
    font-size: 12px;
  }

  .ModalGeneral {
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: calc(100vh + 5vh);
    max-height: calc(100vh + 5vh);
  }

  .closeModal {
    top: 1rem;
    right: 5px;
    width: 30px;
    background: whitesmoke;
    color: red;
  }

  .ContainerBtnFinancial {
    margin-top: 55px;
  }

  .lineSearch {
    margin-left: 0px;
    justify-content: center;
  }

  .searchByMonth {
    width: 80%;
    margin: 10px 0px 0px 0px;
  }

  .BtnFinancial {
    width: 44%;
    height: 33px;
    font-size: 12px;
  }

  .ItemSumFinancial {
    width: 44%;
    height: 50px;
    font-size: 11px !important;
    gap: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  .radio-input {
    font-family: Poppins-Regular, sans-serif !important;
    font-weight: 600;
    font-size: 12px;
    color: rgb(88, 88, 88);
    display: flex;
    width: 100%;
    gap: 30px;
    border-bottom: 1px solid rgb(227, 227, 227);
    justify-content: flex-start;
    align-items: center;
    justify-content: space-around;
  }

  .ItemSumStateFinancial {
    width: 19.8%;
    height: 47px;
    border: 1px solid #006458;
    border-left: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
  }
}
</style>